export const normalizeString = (str: string): string => {
  return str
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s.,\-/()?:'+]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};
